const projectName = import.meta.env.VITE_GLOB_APP_TITLE;

export function warn(message: string) {
  console.warn(`[${projectName} warn]:${message}`);
}

export function error(message: string) {
  throw new Error(`[${projectName} error]:${message}`);
}

// https://dev.to/sharmakushal/hide-all-console-logs-in-production-with-just-3-lines-of-code-pp4
export function dropConsoleOutput(isHidden = false) {
  if (isHidden) {
    console.log = () => {};
    console.dir = () => {};
    console.info = () => {};
    console.error = () => {};
  }
}
